import { useEffect, useState } from "react";
import axios from "axios";
import { useContent } from "../context/ContentContext";
import Navbar from "../components/Navbar";
import { API, useAuth } from "../context/AuthContext";
import { Trophy, Gift, Flag, Target } from "lucide-react";

export default function SeasonLeaderboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null); const [prizeSt, setPrizeSt] = useState(null);
  const { c } = useContent();
  useEffect(() => { axios.get(`${API}/paddock/season/leaderboard`).then(r => setData(r.data)).catch(() => {}); axios.get(`${API}/site/prizes/status`).then(r => setPrizeSt(r.data)).catch(() => {}); }, []);
  const medal = ["text-[#FF9F0A]", "text-slate-200", "text-[#CD7F32]"];

  return (
    <div className="min-h-screen grain-bg">
      <Navbar variant="pro" />
      <section className="pt-28 pb-16 max-w-6xl mx-auto px-5 lg:px-8">
        <div className="rl-banner rl-watermark p-8 md:p-12 mb-8 flex flex-wrap items-center gap-8">
          <img src="/logo-mark.png" alt="" className="w-24 md:w-32 drop-shadow-[0_0_24px_rgba(255,30,39,0.5)]" />
          <div className="relative flex-1 min-w-[260px]">
            <div className="pill-badge pill-amber mb-3"><Trophy className="w-3 h-3" /> CLASSIFICA STAGIONALE {data?.year || 2026}</div>
            <h1 className="headline-huge text-4xl sm:text-5xl mb-2" data-testid="season-title">{c("season.title", "Il campionato dei fan.")}</h1>
            <p className="text-slate-400">{c("season.subtitle", "Tutti i punti sommati su ogni rally della stagione.")}</p>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 rl-card p-5" data-testid="season-table">
            {!data && <div className="text-slate-500 text-center py-8">Caricamento…</div>}
            {data?.rows.map(r => (
              <div key={r.user_id} data-testid={`season-row-${r.pos}`}
                className={`flex items-center justify-between px-4 py-3 border-b border-white/5 ${r.user_id === user?.id ? "bg-[#FF9F0A]/5" : ""}`}>
                <div className="flex items-center gap-4">
                  <div className={`font-display font-black text-2xl w-10 ${medal[r.pos - 1] || "text-slate-600"}`}>P{r.pos}</div>
                  <div><div className="font-semibold">{r.name}{r.user_id === user?.id && <span className="ml-2 pill-badge !py-0 !px-2 !text-[9px]">TU</span>}</div>
                    <div className="text-[11px] font-mono-rl text-slate-500 flex gap-3"><span className="flex items-center gap-1"><Flag className="w-3 h-3" /> {r.rallies} RALLY</span><span className="flex items-center gap-1"><Target className="w-3 h-3" /> {r.wins} PRONOSTICI VINTI</span></div></div>
                </div>
                <div className="font-mono-rl text-xl font-bold">{r.points} <span className="text-xs text-slate-500">pt</span></div>
              </div>))}
          </div>
          <div className="rl-card p-5" data-testid="season-prizes">
            <h3 className="font-display font-bold text-lg flex items-center gap-2 mb-1"><Gift className="w-5 h-5 text-[#FF1E27]" /> Premi finali</h3>
            <div className="pill-badge pill-amber mb-4 inline-flex" data-testid="prizes-status">{(prizeSt?.label || "Premi in fase di definizione").toUpperCase()}</div>
            <div className="space-y-3">
              {data?.prizes.map(p => (
                <div key={p.pos} className="border border-white/5 rounded-lg p-3">
                  <div className={`font-display font-black text-lg ${medal[p.pos - 1] || ""}`}>{p.pos}° posto</div>
                  <div className="text-sm">{p.title}</div>
                  {p.sponsor && <div className="text-[10px] font-mono-rl text-[#FF9F0A] mt-1">OFFERTO DA {p.sponsor.toUpperCase()}</div>}
                </div>))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
